/**
 * Created by inonstelman on 12/28/14.
 */

(function () {
    'use strict';

    // @ngInject
    Services.AdyenCheckout = function adyen($window, ThirdPartyLoaderService) {
        ThirdPartyLoaderService.loadCss('https://checkoutshopper-live.adyen.com/checkoutshopper/sdk/3.6.1/adyen.css');
        return ThirdPartyLoaderService.loadUrlPromise('https://checkoutshopper-live.adyen.com/checkoutshopper/sdk/3.6.1/adyen.js', function() {return $window.AdyenCheckout;});
    };


}());